
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/p/[slug]",
      function () {
        return require("private-next-pages/[locale]/p/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/p/[slug]"])
      });
    }
  